import "@/App.css";
import "@/i18n";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/lib/auth";
import Layout from "@/components/Layout";
import LoginPage from "@/pages/LoginPage";
import MagicLinkVerifyPage from "@/pages/MagicLinkVerifyPage";
import DashboardPage from "@/pages/DashboardPage";
import GroupePage from "@/pages/GroupePage";
import DiagnosticPage from "@/pages/DiagnosticPage";
import CataloguePage from "@/pages/CataloguePage";
import AtelierDetailPage from "@/pages/AtelierDetailPage";
import AtelierEditorPage from "@/pages/AtelierEditorPage";
import RegionalDashboardPage from "@/pages/RegionalDashboardPage";
import ConnexionPage from "@/pages/ConnexionPage";
import AuditLogPage from "@/pages/AuditLogPage";

function ProtectedRoute({ children, roles }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  return <Layout>{children}</Layout>;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-center" richColors />
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/auth/verify" element={<MagicLinkVerifyPage />} />
          <Route path="/" element={<ProtectedRoute><DashboardPage /></ProtectedRoute>} />
          <Route path="/catalogue" element={<ProtectedRoute><CataloguePage /></ProtectedRoute>} />
          <Route path="/atelier/:atelierId" element={<ProtectedRoute><AtelierDetailPage /></ProtectedRoute>} />
          <Route path="/groupe/:groupeId" element={<ProtectedRoute><GroupePage /></ProtectedRoute>} />
          <Route path="/groupe/:groupeId/diagnostic" element={<ProtectedRoute roles={["dr", "dz", "dn", "ceo"]}><DiagnosticPage /></ProtectedRoute>} />
          <Route path="/editor" element={<ProtectedRoute roles={["ceo"]}><AtelierEditorPage /></ProtectedRoute>} />
          <Route path="/regional" element={<ProtectedRoute roles={["dn", "dr", "dz", "ceo"]}><RegionalDashboardPage /></ProtectedRoute>} />
          <Route path="/connexion" element={<ProtectedRoute roles={["president", "coach", "ceo", "dn", "dr"]}><ConnexionPage /></ProtectedRoute>} />
          <Route path="/admin/audit" element={<ProtectedRoute roles={["ceo"]}><AuditLogPage /></ProtectedRoute>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
